import { hideAndRemove } from "./hideAndRemove";

export const hideAndRemoveInArr = (arr) => {
    if (!Array.isArray(arr)) return;

    arr.forEach((obj) => {
        hideAndRemove(obj);
    });
    arr.length = 0;
};
